import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertOctagon } from "lucide-react";

export default function BillingBanner() {
    const [status, setStatus] = useState(null);
    useEffect(() => {
        api.get("/tenant/billing-status").then(r => setStatus(r.data)).catch(() => {});
    }, []);
    if (!status || !status.is_suspended) return null;
    return (
        <div className="fixed top-16 left-0 lg:left-[260px] right-0 z-30 bg-red-900/30 border-b border-red-800 px-6 py-3 flex items-center gap-3" data-testid="billing-banner">
            <AlertOctagon className="w-5 h-5 text-red-400 shrink-0" strokeWidth={1.5}/>
            <div className="text-sm flex-1">
                <span className="font-medium text-red-300">Subscription overdue.</span>
                <span className="text-muted-foreground ml-2">Access is restricted. AutoPay or pay your latest invoice to restore your firm's workspace instantly.</span>
            </div>
            <a href="/app/invoices" className="text-xs bg-primary text-primary-foreground hover:bg-primary px-4 py-1.5 font-medium transition-colors">Pay now</a>
        </div>
    );
}
